// features/module-master.parent.js

// "Is Parent Module" flag rules. A parent module is a sidebar group: it sits at
// the top level with no page path ("#"), and its sub-modules hold the pages.
// The flag isn't stored, so for a saved module it's worked out from its data.
//
// `modules` is every module from the dependencies loader (undefined when that
// call failed).

export const hasSubModules = (id, modules = []) =>
  !!id && modules.some((m) => m.parent_fid !== null && Number(m.parent_fid) === Number(id));

// A saved module is a parent when it's top level and has no page path, or
// already has sub-modules (some older parents also carry a path).
export const isParentModule = (module, modules) =>
  !module.parent_fid && (!module.path || module.path === "#" || hasSubModules(module.id, modules));

// Form values when the flag is switched: a parent drops its parent and path, a
// page gets them back to fill in. Switching back to how the module was saved
// restores its saved values, so toggling back and forth changes nothing.
export const parentFlagChanges = (isParent, formData, modules) => {
  const saved = formData?.id && modules ? modules.find((m) => m.id === Number(formData.id)) : null;
  const restoring = !!saved && isParentModule(saved, modules) === isParent;
  return {
    parent_fid: restoring ? saved.parent_fid ?? "" : "",
    path: restoring ? saved.path ?? "" : isParent ? "#" : "",
  };
};
